import { Helmet } from "react-helmet";
import Authority from "../../components/reusables/Authority";
import SystemDevelopment from "../../components/solutions/system/SystemDevelopment";
import HowWeWork from "../../components/solutions/HowWeWork";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import SystemFaqsBody from "../../components/faqs/SystemFaqsBody";
import RelatedSystem from "../../components/solutions/system/RelatedSystem";

export default function Systems() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/systems-development"
        />
        <meta
          name="description"
          content="Custom software and enterprise systems development including ERP, school management, HR, POS, and other industry-specific systems."
        />
        
        <meta
          property="og:description"
          content="Custom software and enterprise systems development including ERP, school management, HR, POS, and other industry-specific systems."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | Systems Development & Integration"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | Systems Development & Integration"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | Systems Development & Integration"
        />
        <meta
          name="twitter:description"
          content="Custom software and enterprise systems development including ERP, school management, HR, POS, and other industry-specific systems."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>NTUNA.COM | Solutions | Systems Development & Integration</title>
      </Helmet>
      <SolutionItemHero
        title="Systems development & integration"
        subtitle="Fully customized software and enterprise systems development for management, sales, accounting, HR, POS, and other industry-specific systems."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <SystemDevelopment />
      <SolutionCTA ctaTitle="Ready To Have Your System?" />
      <SystemFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your System?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your System?" />
      <RelatedSystem />
    </>
  );
}
